export default __webpack_public_path__ + "static/media/Goggles.faf692a2.png";